
import TableList from "@components/templates/tablelist";
import { HttpGetApplicateList,HttpGetApplicateSubmit,HttpGetApplicateNotes,HttpGetApplicateClose,HttpGetApplicateCancel,HttpGetApplicateCheck,HttpGetApplicateDelete, HttpResetApplication,HttpGetCountpoRequisition,HttpReqRemoveError } from "@/service/purchase/purchase";
import { mapGetters } from "vuex";
import comIndex from './update/index'
import comPurchaseIndex from '../order/update/index'
import comPOpurchase from './update/popurchase'
import mixin from './mixin'
import comExcel from '@components/templates/excelalert'
export default {
    mixins: [TableList,mixin],
    components: {
        comIndex,
        comPOpurchase,
        comPurchaseIndex,
        comExcel
    },
    data() { 
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            spanTabs: { show: true },
            formData:{
                search:{
                    'quanbu': 0,
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename:'',
            datetime:'',
            Plugins: {show: true},
            initData:'',
        };
    },
    // created(){
        // this.timehandle()
    // },
    methods: {
        ajaxRequest: HttpGetApplicateList,
        spanAjaxRequest: HttpGetCountpoRequisition,
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('boss.purchase.select_data',{defaultValue:'请选择至少一条数据'})
                );
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'applicationUpdate',
                        params: { type: "add" },
                        // query: { id: params },
                    });
                    break;
                case "edit":
                    var url=this.$router.resolve({
                        name: "applicationUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('boss.purchase.view',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "autoPO":
                    this.operate = {
                        title: this.$t('boss.purchase.create_PO',{defaultValue:'创建PO'}),
                        show:true,
                        width:1200,
                        component: "comPOpurchase",
                        activeid:params,
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "applicationUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "cactpurchase":
                    this.operate = {
                        title: this.$t('boss.purchase.view',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        component: "comPurchaseIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "cactpurchaseBlank":
                    var url=this.$router.resolve({
                        name: "purchaseOrderUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "notes":
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('boss.purchase.add_note',{defaultValue:'添加备注'}),
                            width: 460,
                            params:{ids:params},
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                    required:false,
                                }
                            ],
                            ajaxRequest:HttpGetApplicateNotes
                        };
                        break;
                case "submitbox":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.submit',{defaultValue:'提交'}),
                        width: 460,
                        params:{ids:params},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                labelWidth:150,
                                required:false,
                            },
                            {
                                tag: "vCheckbox",
                                key: "dingProcessEnable",
                                span: 24,
                                label: this.$t('boss.purchase.submit_Ding_Talk',{defaultValue:'同时提交钉钉申请流程'}),
                                labelWidth:150,
                                required:false,
                                props: {
                                    trueValue: 1,
                                    falseValue: 0,
                                    strict: false,
                                },
                                show:global.SYSID == 1
                            }
                        ],
                        ajaxRequest:HttpGetApplicateSubmit
                    };
                    break;
                case "close":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.close',{defaultValue:'关闭'}),
                        width: 460,
                        params:{ids:params},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpGetApplicateClose
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.cancel',{defaultValue:'取消'}),
                        width: 460,
                        params:{ids:params.id},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                required:false,
                            },
                            // {
                            //     tag: "vCheckbox",
                            //     key: "dingProcessEnable",
                            //     span: 24,
                            //     label: "同时取消钉钉审批",
                            //     labelWidth:150,
                            //     required:false,
                            //     props: {
                            //         trueValue: 1,
                            //         falseValue: 0,
                            //         strict: false,
                            //     },
                            //     show:global.SYSID == 1 && params.dingProcessEnable == 1
                            // }
                        ],
                        ajaxRequest:HttpGetApplicateCancel
                    };
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.delete',{defaultValue:'删除'}),
                        width: 460,
                        params:{ids:params},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpGetApplicateDelete
                    };
                    break;
                case "audit":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.examine',{defaultValue:'审核'}),
                        width: 460,
                        params:{ids:params},
                        formdata: [
                            {
                                tag:'vSelect',
                                key:'orderStatus',
                                label:this.$t('boss.purchase.approval_opinion',{defaultValue:'审批意见'}),
                                options:[
                                    {value:'approved',label:this.$t('boss.purchase.pass',{defaultValue:'通过'})},
                                    {value:'refused',label:this.$t('boss.purchase.reject',{defaultValue:'驳回'})},
                                ],
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpGetApplicateCheck
                    };
                    break;
                    case "reset":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.application_form_reset',{defaultValue:'申请单重置'}),
                        desc: this.$t('boss.purchase.after_resetting',{defaultValue:'重置后，单据将变为草稿状态！'}),
                        width: 460,
                        params:{id:params.id},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                required:false,
                            },
                            // {
                            //     tag: "vCheckbox",
                            //     key: "dingProcessEnable",
                            //     span: 24,
                            //     label: "同时取消钉钉审批",
                            //     labelWidth:150,
                            //     required:false,
                            //     props: {
                            //         trueValue: 1,
                            //         falseValue: 0,
                            //         strict: false,
                            //     },
                            //     show:global.SYSID == 1 && params.dingProcessEnable == 1
                            // }
                        ],
                        ajaxRequest:HttpResetApplication
                    };
                    break;
                    case 'exportMore':
                        console.log(this.$t('boss.purchase.batch_export',{defaultValue:'批量导出'}))
                    break
                    case 'exportQuery':
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/poRequisition/exportDetail", {
                            ...this.exportdata,
                            showmessage:'no'
                        }, {
                            executor: 'request',
                            download: true,
                        }).then(res=>{
                            this.operate = {
                                title: this.$t('boss.purchase.export_query_conditions',{defaultValue:'查询条件导出'}),
                                show: true,
                                width: 560,
                                component: "comExcel",
                                showFooter: false
                            }
                        }).catch(err => {
                            // this.$VMessage.error(err.message);
                        })
                    break
                    case 'delerror':
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('boss.purchase.remove_anomalies',{defaultValue:'去除异常'}),
                            width: 460,
                            params:{ids:params},
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                    required:false,
                                }
                            ],
                            ajaxRequest:HttpReqRemoveError
                        };
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id, orderStatus, poPurchaseRelateEntityList,errorCode,dingProcessEnable } = row
            return [{
                label:this.$t('boss.purchase.submit',{defaultValue:'提交'}),
                show:orderStatus == 'draft',
                params:id,
                operate:'submitbox'
            },{
                label:this.$t('boss.purchase.view',{defaultValue:'查看'}),
                show:true,
                params:id,
                operate:'query'
            },{
                label:this.$t('boss.purchase.edit',{defaultValue:'编辑'}),
                show: orderStatus == 'draft' || orderStatus == 'refused',
                params:id,
                operate:'edit'
            },{
                label:this.$t('boss.purchase.cancel',{defaultValue:'取消'}),
                show: orderStatus == 'approved' || orderStatus == 'refused' ,
                params:{id,dingProcessEnable},
                operate:'cancel'
            },
            {
                label:this.$t('boss.purchase.manually_complete_document',{defaultValue:'手动完成单据'}),
                show: orderStatus == 'approved' && poPurchaseRelateEntityList.length>0,
                params:id,
                operate:'close'
            },{
                label:this.$t('boss.purchase.delete',{defaultValue:'删除'}),
                show: orderStatus == 'draft',
                params:id,
                operate:'delete'
            },{
                label:this.$t('boss.purchase.create_purchase_order',{defaultValue:'创建采购单'}),
                show: orderStatus == 'approved',
                params:id,
                operate:'autoPO'
            },{
                label:this.$t('boss.purchase.examine',{defaultValue:'审核'}),
                show: orderStatus == 'submited',
                params:id,
                operate:'audit'
            },{
                label:this.$t('boss.purchase.add_note',{defaultValue:'添加备注'}),
                show: true,
                params:id,
                operate:'notes'
            },{
                label:this.$t('boss.purchase.application_form_reset',{defaultValue:'申请单重置'}),
                show: orderStatus == 'approved',
                params:{id,dingProcessEnable},
                operate:'reset'
            },{
                label:this.$t('boss.purchase.remove_anomalies',{defaultValue:'去除异常'}),
                show: errorCode >= 1,
                params:id,
                operate:'delerror'
            },
        ]
        },
        interceptRequest(params) {
            
            if (params.search.quanbu === 0) {
                params.search.EQ_orderStatus = '';
            }
            else if (params.search.tijiao === 0) {
                params.search.EQ_orderStatus = 'draft'
            }
            else if (params.search.shenhe === 0) {
                params.search.EQ_orderStatus = 'submited'
            }
            else if (params.search.bohui === 0) {
                params.search.EQ_orderStatus = "refused"
            }
            else if (params.search.caigou === 0) {
                params.search.EQ_orderStatus = 'approved'
                params.search.EQ_poAvailable = 0
            }
            else if (params.search.yichang === 0) {
                params.search.GE_errorCode = 1;
            }

            const {CN_orderNo } = params.search;
            let IN_orderNo;
            if(CN_orderNo){
                IN_orderNo = CN_orderNo.replace(/\n/g,",");
            }
            params.search.IN_orderNo = IN_orderNo;

            delete params.search.quanbu
            delete params.search.tijiao
            delete params.search.shenhe
            delete params.search.bohui
            delete params.search.caigou
            delete params.search.yichang
            delete params.search.CN_orderNo;

            this.exportdata = params;
            return params
        }
    },
    computed: {
        ...mapGetters('diction',['getNewDifferentAllProductList','getAllCostGroupName','getAllCurrency','getNewWarehouseIdList', 'getAllSupplier']),
        ...mapGetters('dictionary', ['getWarehouseAllList']),
        TabsData(){
            return [
                {
                    name: this.$t('boss.purchase.all_procurement_requests',{defaultValue:'所有采购申请'}),
                    key:'quanbu',
                    val: 0,
                    spanKey: 'all',
                }, {
                    name: this.$t('boss.purchase.to_be_submitted',{defaultValue:'待提交'}),
                    key:'tijiao',
                    val: 0,
                    spanKey: 'draft',
                }, {
                    name: this.$t('boss.purchase.pending_approval',{defaultValue:'待审核'}),
                    key:'shenhe',
                    val: 0,
                    spanKey: 'submited',
                }, {
                    name: this.$t('boss.purchase.rejected',{defaultValue:'已驳回'}),
                    key: "bohui",
                    val: 0,
                    spanKey: 'refused',
                }, {
                    name: this.$t('boss.purchase.to_be_purchased',{defaultValue:'待采购'}),
                    key: "caigou",
                    val: 0,
                    spanKey: 'wait_po_order_qty',
                }, 
                {
                    name: this.$t('boss.purchase.abnormal',{defaultValue:'异常'}),
                    key: "yichang",
                    val: 0,
                    spanKey: 'error',
                }
            ]
        },
        ToolsData(){
            return [
                {
                    name: this.$t('boss.purchase.add',{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('boss.purchase.batch_submission',{defaultValue:'批量提交'}),
                    operate: "submitbox",
                    more:true,
                    batch:true
                },
                {
                    name: this.$t('boss.purchase.batch_completion',{defaultValue:'批量完成'}),
                    operate: "close",
                    more:true,
                    batch:true
                },
                {
                    name: this.$t('boss.purchase.batch_add_notes',{defaultValue:'批量添加备注'}),
                    operate: "notes",
                    more:true,
                    batch:true
                },
                {
                    name: this.$t('boss.purchase.export_query_conditions',{defaultValue:'查询条件导出'}),
                    operate: "exportQuery",
                    theme: 'info'
                }
            ]
        },
        getErrorList () {
            return [
                {value:1,label:this.$t('boss.purchase.approval_exception',{defaultValue:'审批异常'})},
                {value:2,label:this.$t('boss.purchase.automatically_calculate_anomalies',{defaultValue:'自动计算异常'})}
            ]
        },
        SearchsData() {
            let stylewidth = "width:210px;"
            return  [
                {
                    label: this.$t('boss.purchase.purchase_request_number',{defaultValue:'采购申请编号'}),
                    key: 'CN_orderNo',
                    show: true,
                    tag: 'vTextarea',
                    class:"inboundtext",
                    props:{
                        placeholder: this.$t('fbb.inbound.input_more_line', { defaultValue: "输入多个，一行一个" }),
                        rows:"1",
                    }
                },
                {
                    label: this.$t('boss.purchase.document_status',{defaultValue:'单据状态'}),
                    tag: 'vSelect',
                    key: 'IN_orderStatus',
                    options: this.getOrderStatus,
                    props:{
                        multiple:true,
                    },
                    show:true,
                },
                {
                    label: this.$t('boss.purchase.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'IN_lineId',
                    options:this.getNewDifferentAllProductList,
                    show:true,
                    props:{
                        filterable:true,
                        multiple:true,
                    }
                },
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'EQ_poRequisitionItem.erpsku',
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.source_no',{defaultValue:'来源单号'}),
                    tag: 'vInput',
                    key: 'EQ_refNo',
                    style: stylewidth,
                },
                
                {
                    label: this.$t('boss.purchase.currency',{defaultValue:'币种'}),
                    tag: 'vSelect',
                    key: 'EQ_currency',
                    options: this.getAllCurrency,
                    style: stylewidth,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: this.$t('boss.purchase.associated_purchase_order',{defaultValue:'关联采购单'}),
                    tag: 'vInput',
                    key: 'CN_poPurchaseRelateEntityList.poOrderNo',
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.notes',{defaultValue:'备注'}),
                    tag: 'vInput',
                    key: 'CN_remark',
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.supplier',{defaultValue:'供应商'}),
                    tag: 'vSelect',
                    options: this.getAllSupplier.map(item => {
                        return {
                            value: item.value,
                            label: `${item.label}(${item.attach.code})`
                        }
                    }),
                    key: 'IN_supplierId',
                    style: stylewidth,
                    props: {
                        filterable:true,
                        multiple:true,
                    }
                },
                {
                    label: this.$t('boss.purchase.warehouse',{defaultValue:'预计接收仓库'}),
                    tag: 'vSelect',
                    options: this.getWarehouseAllList,
                    key: 'IN_expectedReceiveWarehouseId',
                    style: stylewidth,
                    props: {
                        filterable:true,
                        multiple:true,
                    }
                },
                {
                    label: this.$t('boss.purchase.exception_type',{defaultValue:'异常类型'}),
                    tag: 'vSelect',
                    key: 'EQ_errorCode',
                    options: this.getErrorList,
                    style: stylewidth,
                    props: {
                        filterable:true,
                    }
                },
                {
                    label: this.$t('boss.purchase.is_submit_Ding_Talk',{defaultValue:'是否提交钉钉审批'}),
                    tag: 'vSelect',
                    key: 'EQ_dingProcessEnable',
                    options: [
                        {value:1,label:this.$t('boss.purchase.correct',{defaultValue:'是'})},
                        {value:0,label:this.$t('boss.purchase.deny',{defaultValue:'否'})}
                    ],
                    style: stylewidth,
                    hidden:SYSID != 1,
                },
                
                {
                    
                    label: this.$t('boss.purchase.expected_shelf_date',{defaultValue:'预计上架日期'}),
                    tag: 'vDatepicker',
                    key: 'BT_expectedNeedDate',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false
                    },
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.created_at',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: stylewidth,
                },
            ]
        },
        columns() {
            return  [
            {
                show:false,
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: this.$t('boss.purchase.operate',{defaultValue:'操作'}),
                width: 90,
                render:this.getOperateNodes,
            }, {
                title: this.$t('boss.purchase.purchase_request_number',{defaultValue:'采购申请编号'}),
                sortable: true,
                width: 160,
                render:(h,{row,index})=>{
                    const className=`copy_${row.orderNo}_${index}`
                    return <div>
                        <a class={className} onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.orderNo}</a>
                        <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-5 font-14" type="ios-browsers-outline" /></a>
                        <a title={this.$t('boss.purchase.click_copy_tracking',{defaultValue:'点击复制单号'}) } onClick={()=>this.handleCopy(`.${className}`)}><vIcon class="margin-left-5 font-14" type="copy" /></a>
                        </div>
                }
            },
            {
                title: this.$t('boss.purchase.source_tracking_project',{defaultValue:'来源单号/项目'}),
                // key: 'sourceChannel',
                render:(h,{row})=>{
                    const id = row.lineId;
                    const product = this.getNewDifferentAllProductList.filter((item) => {
                        return id == item.value
                    })[0] || {};
                    return <div>
                        <div>{row.refNo || '--'}</div>
                        <div>{product.label || '--'}</div>
                    </div>
                }
            },
            // ||
            {
                title: this.$t('boss.purchase.amount_currency',{defaultValue:'采购金额/币种'}),
                width: 120 ,
                render:(h,{row})=>{
                    return <div>
                        <div>{row.amount}</div>
                        <div>{row.currency}</div>
                    </div>
                }
            },
            {
                title: this.$t('boss.purchase.quantity_total',{defaultValue:'申请总量/待采总量'}),
                width: 120 ,
                render:(h,{row})=>{
                    let allquty=0,allcompqty=0;
                    row.poRequisitionItem.map(item=>{
                        allquty+=Number(item.quantity - item.cancelQuantity)
                        allcompqty+=(item.quantity - item.usedQuantity - item.cancelQuantity)
                    })
                    return <div>
                        <div>{allquty}</div>
                        <div>{( allcompqty < 0 || row.orderStatus=='canceled' || row.orderStatus=='closed') ? 0 : allcompqty}</div>
                    </div>
                }
            },
            {
                title: this.$t('boss.purchase.order_status',{defaultValue:'关联采购单/状态'}),
                render:(h,{row})=>{
                    return (row.poPurchaseRelateEntityList||[]).map((item)=>{
                        return <div>
                            <a onClick={this.handleOperates.bind(this, item.poId, 'cactpurchase')}>{item.poOrderNo}
                            (<span>{this.findRenderLabel(this.getPurchaseOrderStatus,item.poOrderStatus||'draft')}</span>)
                            </a>
                            <a onClick={this.handleOperates.bind(this, item.poId, 'cactpurchaseBlank')}><vIcon class="margin-left-5 font-14" type="ios-browsers-outline" /></a>
                        </div>
                    })
                }
            },
            {
                title: this.$t('boss.purchase.document_status',{defaultValue:'单据状态'}),
                width: 100 ,
                align: "center",
                render:(h,{row})=> {
                    let statusLabel = this.findRenderLabel(this.getOrderStatus,row.orderStatus,'label',true)
                    let errorLabel = this.findRenderLabel(this.getErrorList, row.errorCode, 'label')
                    return <div>
                        <div>{statusLabel}</div>
                        <div class="margin-top-5 color-error" v-show={errorLabel}>{`(${errorLabel})`}</div>
                    </div>
                    
                }
                
            },
            {
                title: this.$t('boss.purchase.DingTalk_approval',{defaultValue:'钉钉审批'}),
                width: SYSID == 1 ? 80 : 0,
                render:(h,{row})=>{
                    return <div>{row.dingProcessEnable == 1 ? this.$t('boss.purchase.correct',{defaultValue:'是'}) : this.$t('boss.purchase.deny',{defaultValue:'否'})}</div>
                }
                
            },
            {
                title: this.$t('boss.purchase.expected_shelf_date',{defaultValue:'预计上架日期'}),
                width: 120 ,
                key:"expectedNeedDate",
                sortable: true,
            },
           {
               title: this.$t('boss.purchase.delivery_time',{defaultValue:'预计交货时间'}),
               width: 120,
               key: "expectedDeliveryDate",
               sortable: true,
           },
            
            {
                title: this.$t('boss.purchase.created_at',{defaultValue:'创建时间'}),
                key:'createdAt'
            },
        ];
        },

    },

};
